import ClaimableAuthenticator from "./claimable-authenticator";

export default ClaimableAuthenticator;
